import React from 'react';
import { GlobalState, Selection } from '@leverege/ui-redux';
import { Flex, Checkbox } from '@leverege/ui-elements';
import { TableModel } from '@leverege/ui-attributes';
import { jsx as _jsx } from "react/jsx-runtime";
const selectColumn = (columns, {
  instance
}) => {
  const {
    context
  } = instance;
  const {
    columns: nCol
  } = context;
  const selectable = TableModel.getSelectable({
    columns: nCol
  });
  const {
    clientProps: {
      targetKey
    }
  } = context;
  const defaultOnCheck = ({
    data,
    value
  }) => {
    const action = value ? 'add' : 'remove';
    GlobalState.dispatch(Selection[action](targetKey, data));
  };
  const defaultCheckAll = ({
    data,
    value
  }) => {
    const {
      page
    } = data;
    const pageItems = page?.map(item => item.original) || [];
    if (value) {
      GlobalState.dispatch(Selection.set(targetKey, pageItems));
    } else {
      GlobalState.dispatch(Selection.clear(targetKey));
    }
  };
  const {
    onCheck = defaultOnCheck,
    onCheckAll = defaultCheckAll
  } = instance;
  const ret = [];
  if (selectable) {
    ret.push({
      id: 'targeted',
      disableFilters: true,
      disableSortBy: true,
      disableResizing: true,
      minWidth: 60,
      maxWidth: 60,
      width: 60,
      Header: data => {
        const {
          targeted,
          page
        } = data;
        const selectedCount = Selection.count(targeted);
        const length = page && page.length || 0;
        const isSelected = selectedCount !== 0 && selectedCount === length;
        return /*#__PURE__*/_jsx(Flex, {
          style: {
            width: '100%'
          },
          justify: "center",
          align: "center",
          children: /*#__PURE__*/_jsx(Checkbox, {
            variant: "small",
            value: isSelected,
            eventData: {
              targeted,
              page
            },
            onChange: onCheckAll
          })
        });
      },
      Cell: data => {
        const {
          row: {
            original
          },
          targeted
        } = data;
        const value = Selection.isSelected(targeted, original.id);
        return /*#__PURE__*/_jsx(Flex, {
          justify: "center",
          align: "center",
          children: /*#__PURE__*/_jsx(Checkbox, {
            variant: "small",
            eventData: original,
            value: value,
            onChange: onCheck
          })
        });
      }
    });
  }
  ret.push(...columns);
  return ret;
};
export default function useSelect(hooks) {
  hooks.allColumns.push(selectColumn);
  hooks.useInstanceBeforeDimensions.push(({
    headerGroups,
    context
  }) => {
    const {
      columns
    } = context;
    const selectable = TableModel.getSelectable({
      columns
    });
    if (selectable) {
      // fix the parent group of the selection button to not be resizable
      const selectionGroupHeader = headerGroups[0].headers[0];
      selectionGroupHeader.canResize = false;
    }
  });
}